<template>
    <div class="additional-description text-left">
        <div v-if="ebayReseller" vocab="http://schema.org/" typeof="Product">
            <span property="description" v-html="descriptionHtml"></span>
        </div>

        <div v-else v-html="descriptionHtml" class="additional-description__content"></div>
    </div>
</template>

<script>
export default {
    name: 'AdditionalDescription',
    props: {
        descriptionHtml: String,
        ebayReseller: {
            type: Boolean,
            required: false
        }
    }
};
</script>

<style scoped lang="scss">
.additional-description__content {
    ::v-deep {
        p:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
